import IExportFormat from '../types/export.interface'

function parseCsv(data: IExportFormat) {
  let csv = 'data:text/csv;charset=utf-8,'
  const csvHeaders = data.exportHeaders.join(';')
  const csvContent = data.exportContent.map((item) => item.join(';'))

  csv += [csvHeaders, ...csvContent].join('\n').replace(/(^\[)|(\]$)/gm, '')

  return encodeURI(csv)
}

export function downloadCsvFile(data: IExportFormat, filename: string) {
  const link = document.createElement('a')
  link.setAttribute('href', parseCsv(data))
  link.setAttribute('download', filename || 'export.csv')
  link.click()

  link.remove()
}

function parseCsvTransco(data: IExportFormat) {
  let csv = 'data:text/csv;charset=utf-8,'
  const csvHeaders = data.exportHeaders
  const csvContent = data.exportContent

  csv += [csvHeaders, ...csvContent].join('\n').replace(/(^\[)|(\]$)/gm, '')

  return encodeURI(csv)
}

// tslint:disable-next-line: max-line-length
export function downloadCsvFileTransco(data: { filename: string, exportHeaders: Array<string | undefined>, exportContent: string[][] }) {
  const link = document.createElement('a')
  link.setAttribute('href', parseCsvTransco({ exportHeaders: data.exportHeaders, exportContent: data.exportContent}))
  link.setAttribute('download', data.filename || 'export.csv')
  link.click()

  link.remove()
}
